import React, { memo, useEffect, useState } from "react";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import stylesPc from "./ContentIndex.module.css";
import stylesSp from "./ContentIndex_SP.module.css";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import FeaturedContentCard from "./featuredContentCard/FeaturedVideoCard";
import ContentList from "./contentList/ContentList";
import { Chip, CircularProgress, createStyles, makeStyles, Theme } from "@material-ui/core";
import { resetfilter } from "../../../common/video/VideoFilterActions";
import FilterWiget from "../../../common/components/filterWiget/FilterWiget";
import { GetAllProgram } from "../../../stores/program/ProgramActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { useInitFlag } from "../../../components/function/useInitFlag";
import { filterVideos, getAllContents } from "../../../common/video/VideoActions";
import { Video } from "../../../common/video/models/Video";
import { Slide } from "../../../models/slides";
import { animateScroll } from "react-scroll";
import { useLocation } from "react-router";
import { t } from "i18next";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tag: {
            marginRight: "16px",
            fontFamily: "noto-sans-cjk-jp,sans-serif",
            backgroundColor: "#333A43",
            textTransform: "none",
            "&:hover": {
                color: "var(--gray-80) !important",
                "& .MuiChip-deleteIcon": {
                    fill: "var(--loading-bg) !important",
                },
            },
            "& .MuiChip-deleteIcon": {
                fill: "#5D5D5D !important",
            },
        },
        msg: {
            marginTop: "65px",
        },
    })
);

interface CheckObject {
    [key: string]: boolean;
}

function ContentIndex() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const classes = useStyles();
    const [checkedItems, setCheckedItems] = useState<CheckObject>({});
    const [isFiltered, setIsFiltered] = useState(false);
    const [msg, setMsg] = useState<string>("");
    // 編集中のフラグ
    const [isEditing, setIsEditing] = useInitFlag();
    // データ取得中フラグ
    const [isLoadingData, setIsLoadingData] = useInitFlag(true);

    // filterが古い順フラグ
    const [isOld, setIsOld] = useState<boolean>(false);

    const {
        userInfo,
        videoFilter,
        video,
        videoList,
        slideList,
        isEditVideo,
        isEditSlide,
        isContentLoading,
    } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        videoFilter: state.videoFilter.videoFilters,
        video: state.video.video,
        videoList: state.video.videoList,
        slideList: state.slide.slideList,
        isEditVideo: state.video.isEditVideo,
        isEditSlide: state.slide.isEditSlide,
        isContentLoading: state.video.isContentLoading,
    }));

    const [currentContent, setCurrentContent] = useState<Video[] | Slide[]>([]);

    //初期表示,フィルタリング時に表示するリスト更新,pathnameで動画とスライドページを分ける
    useEffect(() => {
        if (pathname.match(/^\/video/)) {
            setCurrentContent(videoList);
        } else {
            setCurrentContent(slideList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoList, slideList, pathname]);

    useEffect(() => {
        if (userInfo) {
            // 最初にリスト取得する場合
            if (videoList.length === 0) {
                dispatch(getAllContents(userInfo.id));
            } else {
                dispatch(filterVideos(videoFilter));
            }
            if (
                videoFilter.professional.length > 0 ||
                videoFilter.project.length > 0 ||
                videoFilter.tag.length > 0
            ) {
                setIsFiltered(true);
            } else {
                setIsFiltered(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo, videoFilter, video, isEditSlide]);

    useEffect(() => {
        for (const item of videoFilter.tag) {
            if (!checkedItems[item]) {
                setCheckedItems({
                    ...checkedItems,
                    [item]: true,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedItems]);

    // ビデオ編集後、ビデオ画面に遷移するため、タグのフィルターを初期化する
    useEffect(() => {
        if (isEditVideo === true) {
            setCheckedItems({});
        }
    }, [isEditVideo]);

    // TODO：プログラム管理と一致する？
    // プログラム一覧取得（受講中を含め）
    useEffect(() => {
        // TODO: get ALL
        if (userInfo) {
            dispatch(GetAllProgram(userInfo.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, userInfo]);

    const scrollChange = () => {
        const wigetTop = document.getElementById("wiget")?.offsetTop;
        if (wigetTop) {
            animateScroll.scrollTo(wigetTop + (IsDevice("desktop") ? 0 : 80), {
                duration: 400,
                smooth: true,
            });
        }
    };

    // フィルターの削除イベント
    const delfilter = (type: string, item: string) => {
        switch (type) {
            case "professional":
                {
                    const professionalFilter = {
                        ...videoFilter,
                        professional: videoFilter.professional.filter((i) => i !== item),
                    };
                    dispatch(resetfilter(professionalFilter));
                }
                break;
            case "tag":
                setCheckedItems({
                    ...checkedItems,
                    [item]: false,
                });
                {
                    const tagFilter = {
                        ...videoFilter,
                        tag: videoFilter.tag.filter((i) => i !== item),
                    };
                    dispatch(resetfilter(tagFilter));
                }
                break;
            default:
                console.log("undefined type:" + type);
        }
    };

    const delAllfilter = () => {
        const tagFilter = {
            ...videoFilter,
            tag: [],
            professional: [],
        };

        dispatch(resetfilter(tagFilter));
    };

    const changeProfessionalFilter = (presenterId: string) => {
        const modFilter = {
            ...videoFilter,
            professional: presenterId === "" ? [] : [presenterId],
        };
        dispatch(resetfilter(modFilter));
        scrollChange();
    };

    const changeTagFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedItems({
            ...checkedItems,
            [event.target.name]: event.target.checked,
        });

        const modFilter = { ...videoFilter };
        if (!modFilter.tag.includes(event.target.name) && event.target.checked) {
            modFilter.tag.push(event.target.name);
        } else {
            modFilter.tag = modFilter.tag.filter((t) => t !== event.target.name);
        }
        dispatch(resetfilter(modFilter));
        scrollChange();
    };

    const closeMsg = () => {
        setMsg("");
    };

    // 編集中のフラグ設定
    useEffect(() => {
        if (isEditVideo || isEditSlide) {
            setIsEditing(true);
        }
        // eslint-disable-next-line
    }, [isEditVideo, isEditSlide]);

    // 編集完了
    useEffect(() => {
        if (!isContentLoading && isEditing && !isEditVideo && !isEditSlide) {
            setIsEditing(false);
        }
        // eslint-disable-next-line
    }, [isContentLoading, isEditVideo, isEditSlide]);

    // ローディング完了
    useEffect(() => {
        if (!isContentLoading && isLoadingData) {
            setIsLoadingData(false);
        }
        // eslint-disable-next-line
    }, [isContentLoading]);

    if (isContentLoading || isEditing || isLoadingData) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    const contentList = (
        <>
            <div>
                {currentContent && currentContent.length > 0 && (
                    <div id="wiget">
                        <FilterWiget
                            contents={currentContent}
                            videoFilter={videoFilter}
                            changeProfessionalFilter={changeProfessionalFilter}
                            changeTagFilter={changeTagFilter}
                            setContentList={setCurrentContent}
                            isOld={isOld}
                            setIsOld={setIsOld}
                        />
                    </div>
                )}
                {currentContent.length === 0 && !isContentLoading ? (
                    <div className={styles.noVideo}>
                        {t("ただいま視聴できるContentsがございません")}
                    </div>
                ) : (
                    <div className={isFiltered ? styles.videoArea : ""}>
                        <div>
                            {currentContent && (
                                <div className={isFiltered ? styles.featuredContentCard : ""}>
                                    <FeaturedContentCard
                                        content={currentContent[0]}
                                        setMsg={setMsg}
                                    />
                                </div>
                            )}
                        </div>

                        <div
                            className={styles.filter}
                            style={{
                                marginTop: isFiltered ? "95px" : 0,
                                borderBottom: isFiltered ? "1px solid #2F3538" : "",
                            }}
                        >
                            {videoFilter.tag.map((tag, index) => (
                                <Chip
                                    label={tag}
                                    key={`${index}`}
                                    className={classes.tag}
                                    size="medium"
                                    color="secondary"
                                    style={{
                                        backgroundColor: "#333A43",
                                        color: "var(--loading-bg)",
                                    }}
                                    onDelete={() => delfilter("tag", tag)}
                                />
                            ))}
                            {videoFilter.professional.map((professional, index) => (
                                <Chip
                                    label={professional}
                                    key={`${index}`}
                                    className={classes.tag}
                                    size="medium"
                                    color="secondary"
                                    style={{
                                        backgroundColor: "#333A43",
                                        color: "var(--loading-bg)",
                                    }}
                                    onDelete={() => delfilter("professional", professional)}
                                />
                            ))}
                            <div
                                className={styles.delBtn}
                                style={{
                                    display: isFiltered ? "" : "none",
                                }}
                                onClick={delAllfilter}
                            >
                                <PuiTypography size={14} color="secondary-font">
                                    {t("削除")}
                                </PuiTypography>
                            </div>
                        </div>
                        <div className={styles.list}>
                            {currentContent && isFiltered ? (
                                <ContentList contents={currentContent} setMsg={setMsg} />
                            ) : (
                                <ContentList contents={currentContent.slice(1)} setMsg={setMsg} />
                            )}
                        </div>
                    </div>
                )}
            </div>

            <PuiMessage
                open={msg !== ""}
                type="success"
                title={t("登録に成功しました")}
                detail={[
                    <PuiTypography key={msg} color="black">
                        {msg}
                    </PuiTypography>,
                ]}
                duration={5000}
                onClose={closeMsg}
            />
        </>
    );

    return <div className={styles.root}>{contentList}</div>;
}

export default memo(ContentIndex);
